import React from "react"
import {Box} from "@mui/joy";
import {useUITheme} from "../hooks/useUITheme";

const FullLogo = () => {
    const uiTheme = useUITheme()
    return (<Box component={"img"}
                 width={{xs: 150, sm: 200}}
                 height={"auto"}
                 src={uiTheme.fullLogo}
                 alt={'LinguaScore Logo'}
    />)
}

export default FullLogo